var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"wrapper"},[_c('Header',{attrs:{"title":"保險服務商聯絡資訊","backto":"/"}}),_c('Menu',{attrs:{"menu":_vm.menu}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }